import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, filter, finalize, take } from 'rxjs/operators';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { environment } from 'src/environments/environment';
import {
  GetAllAdlDetails,
  GetAllAdls,
  GetAllUAPs,
  UpdateAdlBody,
} from '../../../models/admin/adl.model';
import { CommonUtils } from '../../../utils/common/common.utils';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class AdlService {
  baseUrl = environment.apiUrl.concat('adl-route-management/');

  constructor(
    private readonly http: HttpClient,
    private readonly commonUtils: CommonUtils,
    private readonly errorHandler: ErrorhandleService,
  ) {}

  getAllADlDetails(locationCode: string): Observable<GetAllAdlDetails> {
    this.commonUtils.updateLoadingModal(true);
    this.commonUtils.lockUpdateLoadingModal(true);
    return this.http
      .get<GetAllAdlDetails>(this.baseUrl.concat(`adl/details/${locationCode}`))
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<GetAllAdlDetails>(
            error,
            error.status,
            'Adl Service: Get All Adl Details',
            BANNER_TYPE.TABLE_DATA_ERROR,
          ),
        ),
      );
  }

  getAllAdlsByLocation(locationCode: string): Observable<GetAllAdls> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<GetAllAdls>(
        this.baseUrl.concat('adl/overview/').concat(locationCode),
      )
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<GetAllAdls>(
            error,
            error.status,
            'Adl Service: Get Adls by Location',
            BANNER_TYPE.TABLE_DATA_ERROR,
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  getUAPLocations(location: string): Observable<GetAllUAPs> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<GetAllUAPs>(this.baseUrl.concat('adl/findUAPLocations'), {
        headers: {
          location: location,
        },
      })
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<GetAllUAPs>(
            error,
            error.status,
            'Adl Service: Get All UAP Locations',
            BANNER_TYPE.UAP_LOCATION_ERROR,
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  editAdls(
    body: UpdateAdlBody[],
    locationCode: string,
  ): Observable<UpdateAdlBody> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .post<UpdateAdlBody>(
        this.baseUrl.concat('adl/assign-unassign'),
        {
          assignUnassignADL: body,
        },
        { headers: { location: locationCode } },
      )
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError(
            error,
            error.status,
            'Adl Service: Edit Adls',
            BANNER_TYPE.API_ERROR,
            false as unknown as UpdateAdlBody,
          ),
        ),
        filter((value) => !!value),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
